module.exports = __webpack_public_path__ + "static/media/l1.7fca878a.gltf";